// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload-trigger-wrapper[data-v-03bc229a] {\n  padding: 10px 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  line-height: 1.2em;\n}\n.upload-trigger-wrapper > * + *[data-v-03bc229a] {\n  margin-top: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
